// App utils
import { datajs, datajsAll, hasScollState, trapFocus, collapseOpenSubnavs, isBreakpointLgUp } from '../shared/utils';

export default class OffCanvasNav {
	static init() {
		const toggleMenuElement = datajs('toggle-off-canvas-section');
		const toggleSiteHeaderSearchBtn = datajs('site-header-search-toggle');
		let isTransitioning = false;
		let isVisible = false;

		if (!toggleMenuElement || !toggleSiteHeaderSearchBtn) {
			return;
		}

		// Handle play/pause between both videos in each block on window resize.
		const breakpointLgUp = window.matchMedia(isBreakpointLgUp);

		const setConditionalPristineState = () => {
			const navsWithUniqueSubnavs = document.querySelectorAll('.js-unique-subnav');

			navsWithUniqueSubnavs.forEach((nav) => {
				if (!nav.querySelector(':scope > .is-active')) {
					nav.classList.add('is-pristine');
				}
			});
		};

		setConditionalPristineState();

		const toggleOffCanvasSection = () => {
			if (isVisible) {
				window.requestAnimationFrame(hideOffCanvasSection);
			} else {
				window.requestAnimationFrame(showOffCanvasSection);
			}
		};

		const showOffCanvasSection = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;

			trapFocus(document.getElementById('off-canvas-section'));
			toggleMenuElement.setAttribute('aria-expanded', 'true');

			// Transition CSS class 1
			document.body.classList.add('has-activated-menu');

			// Transition CSS class 2
			setTimeout(function () {
				document.body.classList.add('has-menu');

				if (hasScollState()) {
					document.body.classList.remove('is-scrollingUp');
				}

				isVisible = true;
				isTransitioning = false;
			}, 10);

			return false;
		};

		const hideOffCanvasSection = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;

			toggleMenuElement.setAttribute('aria-expanded', 'false');

			// Remove Transition CSS class 2
			document.body.classList.remove('has-menu');

			if (hasScollState()) {
				document.body.classList.add('is-scrollingUp');
			}

			// Remove Transition CSS class 1
			setTimeout(function () {
				document.body.classList.remove('has-activated-menu');
				isVisible = false;
				isTransitioning = false;
			}, 650);

			return false;
		};

		const toggleSubNav = (e) => {
			e.preventDefault();
			const target = e.target;
			const parentLi = target.closest('li');
			const parent = parentLi.parentNode;

			// Good idea to match with submenu CSS transition-duration
			const animationDelayMs = 500;

			const show = () => {
				// Remove pristine state
				if (parent.classList.contains('is-pristine')) {
					parent.classList.remove('is-pristine');
				}

				parentLi.classList.add('is-activated');
				setTimeout(function () {
					parentLi.setAttribute('aria-expanded', 'true');
					parentLi.classList.add('is-active');
					parentLi.querySelector('a').setAttribute('aria-current', 'page');
				}, 10);
			};

			const hide = () => {
				parentLi.setAttribute('aria-expanded', 'false');
				parentLi.querySelector('a').removeAttribute('aria-current');
				parentLi.classList.remove('is-active');
				setConditionalPristineState();
				setTimeout(function () {
					parentLi.classList.remove('is-activated');
				}, animationDelayMs);
			};

			// Hide submenu (if already visible) and return
			if (parentLi.getAttribute('aria-expanded') === 'true') {
				hide();
				return;
			}

			/*
			 * Close all open menus before opening a new one
			 * This is an edge case for m-offCanvasNav top level menu
			 */
			if (parent && parent.classList.contains('js-unique-subnav')) {
				collapseOpenSubnavs(animationDelayMs);
			}

			// Show submenu
			show();
		};

		const handleDocumentKeyUp = (e) => {
			// Close menu using Esc key.
			if (e.keyCode === 27) {
				hideOffCanvasSection();
			}
		};

		const watchIsBreakpointLgUp = () => {
			// Small screens
			if (!breakpointLgUp.matches) {
				// Toggle subnavigation items
				datajsAll('subnav-toggle').forEach((item) => item.addEventListener('click', toggleSubNav));
			}
		};

		// Keep track of small/large video visibility breakpoint
		breakpointLgUp.addEventListener('change', watchIsBreakpointLgUp);
		watchIsBreakpointLgUp();

		// Toggle off canvas menu
		toggleMenuElement.addEventListener('click', toggleOffCanvasSection);

		// Hide off canvas overlay if site header search overlay is activated
		toggleSiteHeaderSearchBtn.addEventListener('click', hideOffCanvasSection);

		// Handle document keyup event
		document.addEventListener('keyup', handleDocumentKeyUp);
	}
}
